<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <ngx-view-user-display
            [user]="comment.author"
            [mode]="'avatar'"
          ></ngx-view-user-display>
        </div>

        <div class="content">
          <div class="content-header">
            <div>
              <ngx-view-user-display
                [user]="comment.author"
                [mode]="'name'"
              ></ngx-view-user-display>
              <ngx-view-time-ago
                [currentDate]="comment.createdOn"
              ></ngx-view-time-ago>

              <div *ngIf="comment.refTitle" class="text-link">
                <nb-icon [icon]="comment.iconMode"></nb-icon>
                <a class="link" (click)="navigateRef(comment)">
                  {{ comment.refTitle }}
                </a>
              </div>
            </div>
          </div>

          <div *ngIf="comment.toUid && comment.level > 0" class="text-hint">
            <ngx-view-user-display
              [user]="comment.toAuthor"
              [mode]="'name'"
              [icon]="'at-outline'"
            >
            </ngx-view-user-display>

            <span *ngIf="!comment.moreRefTitle" class="ref-title"
              >: "{{
                comment.refTitle.length < 60
                  ? comment.refTitle
                  : comment.refTitle.substring(0, 60) + "..."
              }}"
            </span>
            <span *ngIf="comment.moreRefTitle" class="ref-title"
              >: "{{ comment.refTitle }}"
            </span>

            <a
              *ngIf="comment.refTitle && comment.refTitle.length >= 60"
              (click)="readMoreRefTitle(comment)"
              class="link"
            >
              <nb-icon
                status="info"
                [icon]="comment.moreRefTitle ? 'chevron-left' : 'chevron-right'"
              ></nb-icon>
            </a>
          </div>

          <div class="view-content">
            {{ comment.content }}
          </div>

          <div class="button-actions">
            <ngx-view-like [comment]="comment"> </ngx-view-like>

            <ngx-button-report-spam
              [comment]="comment"
              (onReport)="report($event)"
            ></ngx-button-report-spam>
          </div>
        </div>
      </div>
    </div>
  </nb-card-header>
</nb-card>
